import { goldenPickScore, type GoldenPick, type Score } from './goldenScore'

interface GoldenScoreRowProps {
  /** The score this fixture is already going to end on. */
  final: Score
  onPick: (score: Score) => void
}

const PICKS: { kind: GoldenPick; label: string; title: string }[] = [
  { kind: 'exact', label: 'Exact', title: 'Dev: predict the score this fixture actually ends on' },
  { kind: 'close', label: 'Close', title: 'Dev: right result, wrong scoreline' },
  { kind: 'miss', label: 'Miss', title: 'Dev: wrong result' },
]

/**
 * The answer sheet, inside the picker.
 *
 * Mock and replica both play every match toward a score that is already written down, and nothing
 * showed it — so checking what an exact-score card does meant guessing, jumping the clock, and
 * resetting the season when the guess landed on the wrong kind of near miss.
 *
 * Deliberately styled as dev chrome, not as part of the game: this sits inside the picker a real
 * person uses in a mock-mode demo, and it must never read as a hint.
 */
export default function GoldenScoreRow({ final, onPick }: GoldenScoreRowProps) {
  return (
    <div className="game-edit-screen__golden">
      <span className="game-edit-screen__golden-label">dev · actual</span>
      <span className="game-edit-screen__golden-score">
        {final.homeScore} — {final.awayScore}
      </span>
      <div className="game-edit-screen__golden-btns">
        {PICKS.map((pick) => (
          <button
            key={pick.kind}
            className="game-edit-screen__golden-btn"
            title={pick.title}
            onClick={() => onPick(goldenPickScore(final, pick.kind))}
          >
            {pick.label}
          </button>
        ))}
      </div>
    </div>
  )
}
